import { Link, Outlet } from "react-router-dom";
import { body, display } from "./AppBits";

const CONTACT_EMAIL = "zinnobyte@gmail.com";

/** Wraps all /apps routes. Deliberately independent from the main site's
 *  Layout so the app studio reads as its own space. */
export default function AppsLayout() {
  return (
    <div style={body} className="flex min-h-screen flex-col bg-[#FFF9F2]">
      {/* -------------------------------------------------- studio header */}
      <header className="bg-[#241663] text-white">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/apps" className="flex items-center gap-2.5">
            <span
              aria-hidden
              className="flex h-9 w-9 items-center justify-center rounded-xl text-lg"
              style={{ background: "linear-gradient(135deg, #FF8A3D, #E8467C)" }}
            >
              😄
            </span>
            <span style={display} className="text-lg font-semibold leading-tight">
              Zinnobyte{" "}
              <span className="text-[#FFC93D] font-medium">App Studio</span>
            </span>
          </Link>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            style={display}
            className="rounded-full border border-white/40 px-4 py-1.5 text-sm font-medium transition-colors hover:bg-white/10"
          >
            Contact us
          </a>
        </div>
      </header>

      {/* ------------------------------------------------------- content */}
      <div className="flex-1">
        <Outlet />
      </div>

      {/* -------------------------------------------------- studio footer */}
      <footer className="bg-[#241633] text-white/80">
        <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
          <p>© {new Date().getFullYear()} Zinnobyte App Studio</p>
          <p>
            Questions or feedback?{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="text-[#FFC93D] font-semibold hover:underline"
            >
              {CONTACT_EMAIL}
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
}
